import { FC } from 'react';
import cx from 'classnames/bind';

import BoxesSad from '@/assets/boxesSad.png';
import CheckCircle from '@/assets/checkCircle.svg';
import { Modal } from '@/components/Modal';

import styles from './ModalIncorrectOrder.module.scss';

interface ModalIncorrectOrderProps {
  modal: string;
  setModal: (value: string) => void;
  setStep: (value: number) => void;
  cigarettes: string;
  answers: string[];
}

const cn = cx.bind(styles);

const ModalIncorrectOrder: FC<ModalIncorrectOrderProps> = ({
  modal,
  setModal,
  setStep,
  cigarettes,
  answers,
}) => {
  const handleClick = () => {
    setStep(3);
    setModal('');
  };

  return modal === 'incorrectOrder' ? (
    <Modal
      src={BoxesSad}
      title="Заказ собран неверно"
      textButton="Выбрать новый заказ"
      handleClick={() => handleClick()}
    >
      <div className={cn('modal-description')}>
        <p className={cn('modal-text')}>
          {answers.length
            ? `Вы выбрали только часть правильных характеристик сигареты ${cigarettes}:`
            : `Вы не смогли выбрать правильные характеристики сигареты ${cigarettes}`}
        </p>
      </div>
      {answers.length ? (
        <ul className={cn('modal-answers')}>
          {answers.map((answer) => (
            <li key={answer} className={cn('modal-answer')}>
              <img
                className={cn('modal-icon')}
                src={CheckCircle}
                alt="Галочка"
              />
              {answer}
            </li>
          ))}
        </ul>
      ) : null}
    </Modal>
  ) : null;
};

export default ModalIncorrectOrder;
